export { default } from './LayoutAccount';
